<template>
  <div class="faqs">
    <div class="container contain-small">
      <h2 class="center">FAQs</h2>

      <div class="tabs">
        <div class="tab">
          <input type="checkbox" id="chck0" checked />
          <label class="tab-label font-large" for="chck0">
            What does "grass-fed" actually mean?
            <i class="fad fa-caret-down fa-lg"></i>
          </label>
          <div class="tab-content">
            In the UK the term ‘grass-fed’ has
            <strong>no legal definition</strong> and can be used to describe
            produce from cattle and sheep that are free to roam and graze and
            are predominantly reared on grass i.e., for at least 51% of their
            lives. There is no specification for what they are fed for the other
            49%, which could be concentrate feeds such as soya, maize, wheat, or
            supplements. The good news is that nearly all British beef is
            grass-fed -
            <strong>but few farms push for 100% grass-fed.</strong>
          </div>
        </div>
        <div class="tab">
          <input type="checkbox" id="chck1" />
          <label class="tab-label font-large" for="chck1">
            What is the difference between grass-fed and pasture-fed meat?
            <i class="fad fa-caret-down fa-lg"></i>
          </label>
          <div class="tab-content">
            In the UK, the words ‘grass-fed’ can be used to describe food from
            animals that have spent only part of their time out grazing in the
            fields or eating conserved grass. The rest of the time they will
            have been fed other less natural feeds, such as cereals or the
            by-products of human food manufacturing like bread and biscuit
            waste. Pasture-fed usually refers to a diet that requires animals be
            100% grass-fed, prohibits the use of supplementary grains and
            proteins, and requires that wildlife and environmental conservation
            measures are in place. Currently,
            <strong
              >the Pasture For Life certification is the only one that
              guarantees 100% grass-fed beef.</strong
            >
          </div>
        </div>
        <div class="tab">
          <input type="checkbox" id="chck2" />
          <label class="tab-label font-large" for="chck2">
            What is the difference between grass-fed and organic meat?
            <i class="fad fa-caret-down fa-lg"></i>
          </label>
          <div class="tab-content">
            Organic farming shares many of the same similaraties as grass-fed
            farming, and many grass-fed products are certified as organic too.
            However, organic certification only requires 60% of the animals’
            feed to come from fresh or dried forage, which means that up to 40%
            can be derived from concentrate feeds such as soya, maize or wheat.
          </div>
        </div>
        <div class="tab">
          <input type="checkbox" id="chck3" />
          <label class="tab-label font-large" for="chck3">
            What are the disadvantages of grass-fed meat?
            <i class="fad fa-caret-down fa-lg"></i>
          </label>
          <div class="tab-content">
            A disadvantage for farmers is that animals raised entirely on grass
            grow and mature more slowly, lengthening the time it takes for them
            to be ready for market.
          </div>
        </div>
        <div class="tab">
          <input type="checkbox" id="chck4" />
          <label class="tab-label font-large" for="chck4">
            How can I be certain what I'm buying only ate grass or forage crops?
            <i class="fad fa-caret-down fa-lg"></i>
          </label>
          <div class="tab-content">
            The best way is to look for the Pasture For Life symbol on the
            label. If you can’t see the Pasture For Life logo, talk to the
            farmer or retailer. Ask them what the animals were given to eat and
            whether they were ever fed grains or other purchased feeds.
          </div>
        </div>
        <div class="tab">
          <input type="checkbox" id="chck5" />
          <label class="tab-label font-large" for="chck5">
            What kinds of animals are grass-fed?
            <i class="fad fa-caret-down fa-lg"></i>
          </label>
          <div class="tab-content">
            In the UK, cattle and sheep are the most commonly found anials that
            graze grass and are sold to consumers. They belong to a family of
            mammals called ruminants, which also include goats, deer, bison,
            buffalo and more.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Faqs"
};
</script>

<style lang="scss">
@import "@/global-styles/variables.scss";

// Layout

.row {
  display: flex;

  .col {
    flex: 1;

    &:last-child {
      margin-left: 1em;
    }
  }
}

// Accordion styles

.tabs {
  border-radius: $border-radius;
  overflow: hidden;

  input {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
}

.tab {
  color: $black;
  overflow: hidden;
  width: 100%;

  &-label {
    border-bottom: 1px solid $grey-4;
    cursor: pointer;
    display: flex;
    font-weight: $bold;
    justify-content: space-between;
    line-height: $line-height;
    margin: 0;
    padding: 1em 0;

    svg {
      margin: 0 0 $spacing-2 $spacing-2;
    }

    // Icon

    &:hover {
      color: $primary;
    }
  }

  &-content {
    background: none;
    color: $black;
    max-height: 0;
    padding: 0;
    transition: max-height, padding 0.35s;
  }

  &-close {
    cursor: pointer;
    display: flex;
    font-size: 0.75em;
    justify-content: flex-end;
    padding: 1em;

    &:hover {
      color: $primary;
    }
  }
}

// :checked

input:checked {
  + .tab-label {
    svg {
      transform: rotate(180deg);
    }
  }

  ~ .tab-content {
    max-height: 100vh;
    padding: 1em 0;
  }
}
</style>
